import { Component, Input } from '@angular/core';
import { ProfitEmployeeSale } from '../../../shared';


@Component({
    selector: 'my-profit-employee',
    styles: [require('./profit-employee.component.scss')],
    template: require('./profit-employee.component.pug')
})

export class ProfitEmployeeComponent {
    @Input() employeeSales: Array<ProfitEmployeeSale>;

    constructor() { }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/profit-loss/profit/profit-employee/profit-employee.component.ts